import { useEffect } from 'react';

export const useScrollTop = (disable = false) => {
  useEffect(() => {
    if (disable) {
      scrollTop();
    }
  }, []);

  const scrollTop = () => window.scrollTo(0, 0);

  return { scrollTop };
};
